/* eslint-disable @typescript-eslint/naming-convention */
import { Component } from '@angular/core';
import { Profile } from '../../../models/profile.model';
import { ArticlesService } from '../../../services/articles.service';
import { StorageProvider } from '../../../services/storage.provider';
import { InfoPopupComponent } from '../../../shared/components/infopopup/infopopup';
import { MetaProvider } from '../../../services/meta.provider';
import { PopUp } from '../../../models/popup.model';
import { PopoverController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-createaccount2',
  templateUrl: 'createaccount2.html',
  styleUrls: ['createaccount2.scss']
})
export class CreateAccount2Page {
  public first_name: string;
  public last_name: string;
  public model: Profile = new Profile('', '', '', '', '', '', '');
  public error: string;
  public isParentActive = true;
  public isEnseignantActive = false;
  public validation: boolean;
  public userstatus: boolean;
  public error_coupon: string;
  public popup: PopUp = new PopUp();
  public tempPopUp: boolean;
  public themeClass: string;

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    private service: ArticlesService,
    public popoverCtrl: PopoverController,
    private storage: StorageProvider,
    private meta: MetaProvider
  ) {
    this.actRoute.queryParamMap.subscribe(
      params => {
        this.model.firstName = params.get('first_name');
        this.model.lastName = params.get('last_name');
      }
    );
  }

  ionViewDidEnter() {
    this.meta.clearHead();
  }

  isLogin(): string {
    return 'login';
  }

  public createProfile(type: string) {
    this.model.type = type;
    const access_token = this.storage.getStorage('access_token');
    this.service.createProfilePost(this.model, access_token).subscribe({
      next:() => {
        if (type === 'Parent') {
          this.router.navigate(['creer-compte', 'etape-3']);
        }
        if (type === 'Teacher') {
          this.router.navigate(['merci'], { queryParams: { page2: 'createprofils' } });
        }

        if (this.storage.getStorage('noProfiles')) {
          this.storage.removeStorage('noProfiles');
        }
      },
      error:(error) => {
        if (error.message === 'Ce code n\'existe pas, veuillez réessayer.') {
          this.error_coupon = 'true';
        } else {
          this.error = ' Vos identifiants ne sont pas reconnus';
        }
      }
    });
  }


  public checkOnBlur() {
    if (this.model.password2 === '') {
      this.userstatus = false;
    } else {
      this.userstatus = true;
    }
    if (this.model.password !== this.model.password2) {
      this.validation = false;
    } else {
      this.validation = true;
    }
  }

  async presentPopover(myEvent) {
    const popover = this.popoverCtrl.create({
      component: InfoPopupComponent,
      componentProps: { page: 'step2' },
      cssClass: 'password-tooltip'
  });
    (await popover).present(myEvent);
  }

  async presentPopover2(myEvent) {
    const popover = this.popoverCtrl.create({
      component: InfoPopupComponent,
      componentProps: { page: 'step2-numeroabo' },
      cssClass: 'password-tooltip'
    });
    (await popover).present(myEvent);
  }

  public changeHandler(): void {
    if (!this.model.coupon) {
      this.error_coupon = '';
    }
  }

  showTempPopUp() {
    this.tempPopUp = true;
    this.popup.type = 'devoir';
    this.popup.data = this.themeClass;
  }

  public onNotifyPopUp(message: string): void {
    this.tempPopUp = false;
  }

  async presentPopover3(myEvent) {
    const popover = this.popoverCtrl.create({
      component: InfoPopupComponent,
      componentProps: { page: 'step3-promocode' },
      cssClass: 'password-tooltip'
    });
    (await popover).present(myEvent);
  }
}
